import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import config from '../config';
import { createAuth } from '../Helpers';

export const reducerName = 'drNewsState';

export const getNews = createAsyncThunk(
    'drNewsState/getNews',
    async (_, { getState, rejectWithValue }) => {
        try {
            const response = await axios({
                method: 'GET',
                url: `${config.server}/api/adminOptions/drrss`,
                withCredentials: true,
                auth: createAuth(getState),
            });
            const data = response.data.rss.channel.item;
            return data;
        } catch (error) {
            return rejectWithValue(error.response?.data || 'An error occurred');
        }
    }
);

const initialState = {
    news: [],
    status: 'idle',
    error: null,
};

const drNewsSlice = createSlice({
    name: reducerName,
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getNews.pending, (state) => {
                state.status = 'loading';
                state.error = null; 
            })
            .addCase(getNews.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.news = action.payload;
            })
            .addCase(getNews.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload || 'An error occurred'; 
            });
    },
});

export default drNewsSlice.reducer;